import { useState } from "react";
import { apiPost, prettifyApiError } from "@/shared/api";
import type { Order } from "../types";
import { ACTION_ICON_CLS, ActionButton } from "./ActionButton";
import { IconSend } from "./icons";

/** Vero se OM ha assegnato a questo ordine un pezzo del magazzino BS COM
 *  (``raw.om_magazzino_bscom.stato``, backend ``orders/in_casa.py``). */
export function assegnatoAlMagazzino(order: Order): boolean {
  const voce = order.raw?.om_magazzino_bscom as { stato?: unknown } | undefined;
  return voce?.stato === "assegnato";
}

/** «Manda al fornitore»: l'unica uscita da «in magazzino» (Davide 2026-10-21:
 *  «quando un prodotto è in magazzino ha sempre la priorità e DEVE uscire prima
 *  quello, gli automatismi si fermano per quell'ordine»). Serve solo se il pezzo
 *  a scaffale non va bene (rotto, gia' venduto altrove): il pezzo torna libero
 *  e l'ordine rientra nel giro normale del fornitore. Chiede conferma perche'
 *  dopo, gli automatismi possono comprarlo davvero. */
export function MagazzinoRilasciaButton({
  order,
  onDone,
  variant = "tile",
}: {
  order: Order;
  onDone?: () => void;
  /** ``inline`` nella testata della pagina ordine (vedi ActionButton). */
  variant?: "tile" | "inline";
}) {
  const [busy, setBusy] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);
  if (!assegnatoAlMagazzino(order)) return null;
  return (
    <span className="relative inline-flex">
      <ActionButton
        tone="amber"
        icon={<IconSend className={ACTION_ICON_CLS} />}
        label={variant === "inline" ? "Manda al fornitore" : "Al forn."}
        variant={variant}
        busy={busy}
        ariaLabel={`Manda al fornitore l'ordine ${order.id}`}
        title={
          errore ??
          "Il pezzo in magazzino non va bene: libera il pezzo e rimanda l'ordine al giro normale del fornitore"
        }
        onClick={(e) => {
          e.stopPropagation();
          if (
            !window.confirm(
              `Mandare ${order.id} al fornitore?\n\nIl pezzo nel magazzino BS COM torna libero e gli automatismi potranno comprare l'ordine dal fornitore.`,
            )
          )
            return;
          setBusy(true);
          setErrore(null);
          void apiPost(`/api/orders/${encodeURIComponent(order.id)}/magazzino/rilascia`)
            .then(() => onDone?.())
            .catch((err: unknown) => setErrore(prettifyApiError(err)))
            .finally(() => setBusy(false));
        }}
      />
      {errore && (
        <span
          role="alert"
          className="absolute -bottom-1 right-0 z-10 translate-y-full whitespace-nowrap text-[10px] text-red"
        >
          {errore}
        </span>
      )}
    </span>
  );
}
